import React, { useState, useEffect } from "react";
import axios from "axios";
import { ADMIN_URL } from "../utils/constants";

export const CreatorContext = React.createContext({
	creator: null,
	setCreator: () => {},
});

export const CreatorProvider = ({ children }) => {
	const [loading, setLoading] = useState(true);
	const [creator, setCreator] = useState(null);

	function splitCap(texto) {
		return texto.replace(/([A-Z])/g, " $1").trim();
	}

	const getCreator = async () => {
		try {
			let res = await axios.get(ADMIN_URL + "creators", {
				params: {},
				headers: { Authorization: localStorage.getItem("token") },
			});
			res.data.fontFamilyCap = splitCap(res.data.fontFamily);
			setCreator(res.data);
			setLoading(false);
		} catch (error) {
			console.log(error);
			setCreator(null);
			setLoading(false);
		}
	};

	useEffect(() => {
		getCreator();
	}, []);

	return (
		<CreatorContext.Provider value={{ creator, setCreator, getCreator }}>
			<>{loading ? null : children}</>
		</CreatorContext.Provider>
	);
};
